import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import CommonDataService from "../../services/common";
import { setLoading } from "../../store/actions/commonAction";

export default function ShortCut() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	let { source } = useParams();

	useEffect(() => {
		dispatch(setLoading(false));
		CommonDataService.getShortCutId(source)
			.then((res) => {
				navigate("/editnews/" + res.data + "?source=" + source);
			})
			.catch(function (error) {
				dispatch(setLoading(false));
			});
	}, [source, dispatch, navigate]);
}
